import { useDispatch, useSelector } from 'react-redux';
import { getRegion } from 'utils/Region';
import { getFavorites } from 'containers/Vcard/actions/favorite/favorite.actions';
import { useEffect } from 'react';
import { jsonParseCatch } from 'utils/getTranslation';

export const useFetchFavorites = (groupId = 0) => {
  const dispatch = useDispatch();
  const userHash = useSelector(state => state.user?.userhash);
  const userData = useSelector(state => state?.user)
  const byrFilterlist =
    useSelector(state => state.metadata?.byr_filterlist_configuration) || '';
  const filterlist =
    jsonParseCatch(byrFilterlist)?.[getRegion()]?.filterlist || '';
  const favorites = useSelector(state => state?.favorites);
  const isFavorite = favorites?.find(fav => fav?.id === groupId);
  const addContentToFavorite =
    JSON.parse(localStorage.getItem('addToFavorite')) || '';

  useEffect(
    () => {
      if (addContentToFavorite && !isFavorite) return;
      if (userHash) dispatch(getFavorites({ user_hash: userHash, filterlist }));
    },
    [!!userHash, userData?.user_id],
  );
};
